import React, { FC } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ThemeProvider, createTheme } from "@mui/material";
import { vars } from "../Variables";

const { primaryFont } = vars;

interface ICustomTable {
  data: any[];
  headRowSx?: Object;
  bodyRowSx?: Object;
  tableSx?: Object;
  heading?: any[];
}

declare module "@mui/material/styles" {
  interface Theme {}
  // allow configuration using `createTheme`
  interface ThemeOptions {}
}

const theme = createTheme({
  components: {
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:not(.MuiTableRow-head):nth-of-type(even)": {
            background: "#F9F9F9",
          },
        },
        head: {
          background: "#EDEDF2",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        body: {
          lineHeight: "143%",
          padding: "10px 12px",
        },
        root: {
          padding: "12px",
          fontWeight: 400,
          fontSize: "14px",
          letterSpacing: "normal",
          lineHeight: "14px",
          color: "#292929",
          fontFamily: primaryFont,
          border: "none",
        },
      },
    },
  },
});

export const CustomTable: FC<ICustomTable> = ({
  data,
  heading,
  headRowSx,
  bodyRowSx,
  tableSx,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <TableContainer>
        <Table sx={tableSx} aria-label="simple table">
          {heading && (
            <TableHead>
              <TableRow sx={headRowSx}>
                {heading?.map((item, index) => (
                  <TableCell
                    key={item.id || index}
                    align={item.align ? item.align : ""}
                  >
                    {item.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          )}

          <TableBody>
            {data?.map((item, index) => {
              return (
                <TableRow key={item.id || index} sx={bodyRowSx}>
                  {Object.keys(item).map((key, index) => (
                    <TableCell
                      key={index}
                      align={item.align ? item.align : ""}
                    >
                      {item[key]}
                    </TableCell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </ThemeProvider>
  );
};
